import { getModifyDataTwo } from '@/api/index'

export function GetModifyData_SB_QS (data) {
  return getModifyDataTwo.request({
    method: 'post',
    url: '/GetModifyData_SB_QS',
    data
  })
}
